import {
  initialState,
  Actions,
  State,
  DELETE_FACTURACION,
  DELETE_FACTURACION_SUCCESS,
  DELETE_FACTURACION_ERROR,
  RESET_DELETE_FACTURACION,
} from "../../types/facturacion/delete";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case DELETE_FACTURACION:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case DELETE_FACTURACION_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case DELETE_FACTURACION_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      };
    case RESET_DELETE_FACTURACION:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducers;
